module.exports = __webpack_public_path__ + "static/media/mail_preview_v2.6c164a6e.jpg";